export const ROUTES = {
	WELCOME: 'welcome',
	OTP: 'send-otp',
	VERIFY: 'verify-identity',
	VERIFIDATA: 'verification-data',
	EMPLOYMENT: 'employment-and-address',
	FINANCIAL: 'financial-data',
	DOCUMENTS: 'loading-documents',
	DEBIT_CARD: 'debit-card',
	TERMS: 'terms-conditions',
	FINISHED: 'costumer-finished',
	DOWNLOAD_APP:'downloadApp'
};
